import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Caption from 'LuxKit/Typography/Caption'
import TextLink from 'LuxKit/TextLink'
import type { PlaceDescription } from 'tripPlanner/utils/placeDescription'

interface Props {
  attribution: NonNullable<PlaceDescription['attribution']>
}

function PlaceDescriptionAttribution({ attribution }: Props) {
  const intl = useIntl()

  return (
    <Group direction="horizontal" gap={8} verticalAlign="center" wrap="wrap">
      <Caption variant="medium" colour="light-foreground-alt">
        {attribution.disclosureText}
      </Caption>
      <TextLink
        size="caption"
        href={attribution.flagContentUri}
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage({
          id: 'BBC0PnZkMWsh8r7D8uVs',
          defaultMessage: 'Report',
          description: 'Link beside an AI-written place summary that opens Google’s report-content page for it',
        })}
      </TextLink>
    </Group>
  )
}

export default PlaceDescriptionAttribution
